import { validate } from 'sha-el-design/lib';
import { UserDetailMutationInput } from '../../../schema';

export const userDetailSchema = validate<UserDetailMutationInput>(validate.Object({
  states: validate.Array(validate.Object({
    state: validate.Text(),
  })),
  towns: validate.Array(validate.Object({
    town: validate.Text(),
  })),
  areas: validate.Array(validate.Object({
    area: validate.Text(),
  })),
  employee: validate.Text().required('Employee is required'),
  username: validate.Text().required('User Name is required'),
  password: validate.Text().required('Password is required'),
  userType: validate.Text().required('User Type is required'),
  supervisor: validate.Text(),
}));

export const userSchema = validate(validate.Object({
  username: validate.Text().required('Username is required'),
  password: validate.Text().required('Password is required'),
}));

export const queryString = `
query userData($user_AuthToken: ID) {
  allUserDetails(user_AuthToken: $user_AuthToken) {
    edges{
      node{
        id
        userType
        isWorkActive
        employee {
          id
          name
        }
        user {
          id
          username
        }
        areas
        towns
        states
      }
    }
  }
}`;

export const userDetailDropdownQuery = `
query allUserDetails($name: String){
  allUserDetails(user_Username_Icontains:$name, userType: "CALLER") {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        user{
          id
          username
        }
        employee {
          id
          name
        }
        userType
      }
    }
  }
}
`;

export const mutation = `
mutation UserDetail($input: UserDetailMutationInput!) {
  createUserDetail(input: $input) {
    id
    employee
    errors {
      field
      messages
    }
  }
}
`;

export const userDetailListQuery = `
query userDetailQuery($after: String!, $name: ID) {
  allUserDetails(first: 20, after: $after, employee_Name_Icontains:$name) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        states
        towns
        areas
        employee {
          id
          name
        }
        user {
          id
          username
        }
        userType
        supervisor {
          id
          employee {
            id
            name
          }
        }
      }
    }
  }
}
`;

export const userDetailEditQuery = `
query userDetailQuery($id: ID!) {
  userDetail(id: $id) {
    id
    states
    towns
    areas
    employee {
      id
      name
    }
    user {
      id
      username
      password
    }
    userType
    stateList {
      id
      name
    }
    townList {
      id
      name
    }
    areaList {
      id
      name
    }
    supervisor {
      id
      employee {
        name
      }
    }
  }
}
`;
